export default __webpack_public_path__ + "static/media/question-white.4e000502.svg";